const featureData = [
  {
    icon: 'ri-shield-check-line',
    title: '官方安全认证',
    desc: '51漫画网作为官方入口，严格保障用户访问安全，杜绝恶意跳转与虚假链接，让您安心畅读。',
  },
  {
    icon: 'ri-hd-line',
    title: '高清画质呈现',
    desc: '所有漫画资源均采用高清扫描与优化处理，即使放大观看依然清晰细腻，阅读体验一流。',
  },
  {
    icon: 'ri-speed-up-line',
    title: '极速加载畅读',
    desc: '智能预加载技术确保翻页流畅无卡顿，51漫画网页版打开即可阅读，无需漫长等待。',
  },
  {
    icon: 'ri-smartphone-line',
    title: '多端无缝切换',
    desc: '支持桌面端、平板与手机访问，51漫画网址统一入口，不同设备同步阅读进度。',
  },
  {
    icon: 'ri-refresh-line',
    title: '每日同步更新',
    desc: '热门连载每日更新，第一时间同步最新话，51漫画官网版始终保持内容新鲜度。',
  },
];

export default function FeaturesSection() {
  return (
    <section id="features" className="py-14 md:py-20 bg-background-100">
      <div className="w-full px-4 md:px-6 max-w-7xl mx-auto">
        <div className="text-center mb-10">
          <h2 className="font-heading text-2xl md:text-3xl font-bold text-foreground-950 mb-3">
            平台优势
          </h2>
          <p className="text-sm text-foreground-500">为什么千万漫迷选择51漫画网</p>
        </div>
        <div className="grid grid-cols-1 sm:grid-cols-2 lg:grid-cols-5 gap-5">
          {featureData.map((item, i) => (
            <div key={i} className="bg-background-50 rounded-xl p-6 text-center group hover:bg-background-50 transition-colors duration-200">
              <div className="w-12 h-12 flex items-center justify-center mx-auto mb-4 rounded-full bg-primary-100/80">
                <i className={`${item.icon} text-xl text-primary-600`}></i>
              </div>
              <h3 className="font-heading text-sm font-semibold text-foreground-900 mb-2">{item.title}</h3>
              <p className="text-xs text-foreground-500 leading-relaxed">{item.desc}</p>
            </div>
          ))}
        </div>
      </div>
    </section>
  );
}